import { Injectable } from '@angular/core';
import { APIConstants, Constants } from '../../common';
import { IActions, IModules, IPermission, IResponseMessage, IRole } from '../../models';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private http: HttpClient) { }

  getAllUserRoles(): Observable<IRole[]> {
    return this.http.get<IRole[]>(APIConstants.roles);
  }

  getAllActions(): Observable<IActions[]> {
    return this.http.get<IActions[]>(APIConstants.actions);
  }

  getAllModules(): Observable<IModules[]> {
    return this.http.get<IModules[]>(APIConstants.modules).pipe(
      map(modules => modules.filter(m => m.name != Constants.screenNames.settings && m.name != Constants.screenNames.dashboard))
    );
  }


  getPermissionByRoleID(role_id: number): Observable<IPermission[]> {
    return this.http.get<IPermission[]>(APIConstants.permissionByRoleID + '?role_id=' + role_id);
  }

  updatePermission(permission: IPermission[]): Observable<IResponseMessage> {
    return this.http.put<IResponseMessage>(APIConstants.permissionByRoleID, permission);
  }

  generateReport(limit: number, offset: number, module: string, start_date: string | null, end_date: string | null) {
    return this.http.get<any>(APIConstants.generateReport + `?limit=${limit}&offset=${offset}&module=${module}&start_date=${start_date}&end_date=${end_date}`);
  }

  downloadReport(start_date: string | null, end_date: string | null, report_format: string | null, report_data: any[]): Observable<Blob> {
    const url = APIConstants.downloadReport + `?start_date=${start_date}&end_date=${end_date}&report_format=${report_format}`;
    return this.http.post(url,
      { template: 'media_report.html', result: report_data },
      { responseType: 'blob' }
    );
  }

  getContentDetailReport(contentId: string, startDate: string, endDate: string) {
    return this.http.get<any>(APIConstants.contentDetailReport + `${contentId}/?start_date=${startDate}&end_date=${endDate}`);
  }

  getScreenDetailReport(screenCode: string, startDate: string, endDate: string) {
    return this.http.get<any>(APIConstants.screenDetailReport + `${screenCode}/?start_date=${startDate}&end_date=${endDate}`);
  }

}
